import { useAbility as _useAbility } from "@casl/vue";
/**
 * Returns the reactive CASL ability instance for the current user.
 * Typed to AppAbility for autocompletion of actions and subjects.
 *
 * Usage:
 *   const { can, cannot } = useAbility();
 *   if (can('read', 'Provider')) { ... }
 */
export function useAbility() {
    return _useAbility();
}
